import { useState, useEffect } from "react";
import { useNavigate, useLocation  } from "react-router-dom";
import { useErrorPopup } from "../components/ui/ErrorPopupContext";
const useAxiosFunction = () =>{
    const [response, setResponse] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [controller, setController] = useState();
    const [showErrorPopup, setShowErrorPopup] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const { showError } = useErrorPopup();

    const axiosFetch = async (configObj)=>{
        const{
            axiosInstance,
            method,
            url,
            requestConfig = {}
        }= configObj;

        try{
            setLoading(true);
            const ctrl = new AbortController();
            setController(ctrl);
            const res = await axiosInstance({
                url, 
                method: method.toLowerCase(),
                ...requestConfig,
                signal: ctrl.signal,
                });
            setResponse(res.data);
            return res.data;
        }catch(err){
            if (err.name === 'CanceledError' || err.message === 'cancelled' || err.code === 'ERR_CANCELED') {
                // Request was cancelled, ignore or handle silently
                console.log('Request was cancelled');
            } else {
                const message = err.response
                ? `Error ${err.response.status}: ${err.response.statusText || 'Request failed'}`
                : err.message || 'Unknown error';
                setError(message);
                showError(message);
                // Decide target based on current page
                const redirectTarget = location.pathname === "/public" ? "/public" : "/";

                setTimeout(() => {
                navigate(redirectTarget);
                }, 3000);
            }

        }finally{
            setLoading(false);
        }
    }

    useEffect(()=>{
        //useEffect cleanup function
        return ()=> controller && controller.abort();  
    },[controller])

    // Effect to navigate after user sees the popup
  useEffect(() => {
    if (showErrorPopup) {
      // For example, navigate after 3 seconds
      const timer = setTimeout(() => {
        setShowErrorPopup(false);
        navigate('/');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showErrorPopup, navigate]);

    return [response,error,loading,axiosFetch]
}

export default useAxiosFunction